<template>
  <SimpleDictView
    endpoint="user-categories/"
    :title="$t('settings.titles.userCategories')"
    :add-button="$t('settings.addButtons.userCategory')"
    :fields="fields"
  />
</template>

<script>
import SimpleDictView from './SimpleDictView.vue'
export default {
  name: 'UserCategoriesView',
  components: { SimpleDictView },
  computed: {
    fields() {
      return [{ key: 'name', label: this.$t('settings.fields.name'), placeholder: this.$t('settings.placeholders.userCategoryName') }]
    },
  },
}
</script>
